@if (beslut) {
  <div class="container-fluid" [@fadeInAnimation]="beslut.length">
    <div class="row">
      <div class="col-xl-2"></div>
      <div class="col-xl-8">
        @if (!beslut.length) {
          <p class="text-muted">{{ 'label.ingen-info' | translate }}</p>
        }
        @if (isImpersonating) {
          <div class="card mb-3">
            <div class="card-header">
              <fa-icon [icon]="['fas', 'eye']" size="lg" class="me-2" [fixedWidth]="true"></fa-icon>
              Ser vy som {{ nameOfAnstalld }}
            </div>
            <div class="card-body">
              <a class="btn-garanti btn-blue" (click)="goBackToArende()">
                <fa-icon [icon]="['fas', 'arrow-left']" class="me-2"></fa-icon>Klicka här för att återgå
              </a>
            </div>
          </div>
        }
        @if (beslut.length) {
          <div class="card mb-3">
            <div class="card-header">
              <fa-icon [icon]="['fas', 'gavel']" size="lg" class="me-2" [fixedWidth]="true"></fa-icon>{{ 'label.mina-beslut-hos-instans' | translate:{instans: instanceName} }}
            </div>
            @for (b of beslut | orderBy: 'arende.beslutsdag':true; track b) {
              <div class="card-body">
                <ul class="list-unstyled">
                  <li class="h5 text-bold">{{ 'label.uppgifter-om-arendetyp' | translate:{ typ: 'label.' + (b.arende.arendeTyp.typ === 'kk' ? 'konkurs' : 'foretagsrekonstruktion') | translate | lowercase } }}</li>
                  @if (b.arende.galdenar) {
                    <li class="text-bold">{{ b.arende.galdenar.orgnr }} {{ b.arende.galdenar.namn }}</li>
                  }
                  <li class="mt-2">
                    {{ 'label.' + (b.arende.arendeTyp.typ === 'rek' ? 'beslutsdag' : 'konkursdag') | translate }}
                    <ul class="list-unstyled ms-3">
                      <li class="text-bold">{{ b.arende.beslutsdag | localizeddate:'shortDate' }}</li>
                    </ul>
                  </li>
                  @if (b.arende.forvaltare) {
                    <li class="mt-2">
                      {{ 'label.' + (b.arende.arendeTyp.typ === 'kk' ? 'konkursforvaltare' : 'foretagsrekonstruktor') | translate }}
                      <ul class="list-unstyled ms-3">
                        <li class="text-bold">{{ b.arende.forvaltare.fornamn }} {{ b.arende.forvaltare.efternamn }}</li>
                      </ul>
                    </li>
                  }
                  @if (b.arende.huvudHandlaggareEntitet) {
                    <li class="mt-2">
                      {{ 'label.kontaktperson' | translate }}
                      <ul class="list-unstyled ms-3">
                        <li class="text-bold">{{ b.arende.huvudHandlaggareEntitet.fornamn }} {{ b.arende.huvudHandlaggareEntitet.efternamn }}</li>
                        @if (b.arende.huvudHandlaggareEntitet.telefon) {
                          <li>
                            <a [href]="'tel:' + b.arende.huvudHandlaggareEntitet.telefon">{{ b.arende.huvudHandlaggareEntitet.telefon }}<fa-icon [icon]="['fas', 'phone']" size="sm" class="ms-2"></fa-icon></a>
                          </li>
                        }
                        @if (b.arende.huvudHandlaggareEntitet.epost) {
                          <li>
                            <a [href]="'mailto:' + b.arende.huvudHandlaggareEntitet.epost">{{ b.arende.huvudHandlaggareEntitet.epost | lowercase }}<fa-icon [icon]="['fas', 'at']" size="sm" class="ms-2"></fa-icon></a>
                          </li>
                        }
                      </ul>
                    </li>
                  }
                  <li class="mt-2">
                    {{ 'label.utbetalande-myndighet' | translate }}
                    @if (b.arende.handlaggsAvSkatteverket) {
                      <ul class="list-unstyled ms-3">
                        <li class="text-bold" title="{{ 'label.skatteverket' | translate }}">{{ 'label.skatteverket' | translate }}<fa-duotone-icon [icon]="['fac', 'skv']" size="lg" class="ms-2"></fa-duotone-icon></li>
                      </ul>
                    } @else {
                      <ul class="list-unstyled ms-3">
                        <li class="text-bold" title="{{ 'label.lansstyrelsen-i' | translate }} {{ b.arende.lansstyresle?.namn }}">{{ 'label.lansstyrelsen-i' | translate }} {{ b.arende.lansstyresle?.namn }}<fa-duotone-icon [icon]="['fac', 'lst']" size="lg" class="ms-2"></fa-duotone-icon></li>
                      </ul>
                    }
                  </li>
                  @if (b.arende.tingsratt) {
                    <li class="mt-2">
                      {{ 'label.tingsratt' | translate }}
                      <ul class="list-unstyled ms-3">
                        <li><span class="text-bold">{{ b.arende.tingsratt.namn }}</span>, {{ b.arende.arendenummer }}</li>
                      </ul>
                    </li>
                  }
                </ul>
                <hr />
                <p class="h5">{{ 'label.mina-beslut' | translate }}</p>
                @if (!b.lonegarantiBeslut.length) {
                  <p class="text-muted">{{ 'label.inga-beslut' | translate }}</p>
                }
                @if (b.lonegarantiBeslut.length) {
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col" [title]="'label.beslut' | translate" class="text-center-sm-left" style="width:95px">{{ 'label.beslut' | translate }}</th>
                        <th scope="col" [title]="'label.datum' | translate" style="width:120px">{{ 'label.datum' | translate }}</th>
                        <th scope="col" [title]="'label.period' | translate" class="hidden-xs-down">{{ 'label.period' | translate }}</th>
                        <th scope="col" [title]="'label.lonegaranti' | translate" class="text-end">{{ 'label.lonegaranti' | translate }}</th>
                        <th scope="col" [title]="'label.dokument' | translate" class="text-center" style="width:140px">{{ 'label.dokument' | translate }}</th>
                        @if (hasForsakransKrav(b.lonegarantiBeslut)) {
                          <th scope="col" [title]="'label.forsakranskrav-' + (b.arende.handlaggsAvSkatteverket ? 'skv' : 'lst') + '-header' | translate" class="text-center" style="width:140px">{{ 'label.forsakran' | translate }}</th>
                        }
                      </tr>
                    </thead>
                    <tbody>
                      @for (c of b.lonegarantiBeslut | orderBy:'datum':true; track c) {
                        <tr>
                          <td [attr.data-name]="'label.beslut' | translate" class="text-center-sm-left"><beslut-icon [arendeTyp]="b.arende.arendeTyp" [beslutTyp]="c.beslutTyp"></beslut-icon></td>
                          <td [attr.data-name]="'label.datum' | translate">{{ c.datum | localizeddate:'shortDate' }}</td>
                          <td [attr.data-name]="'label.period' | translate" class="hidden-xs-down">{{ c.periodFrom | localizeddate:'shortDate' }} &ndash; {{ c.periodTom | localizeddate:'shortDate' }}</td>
                          <td [attr.data-name]="'label.lonegaranti' | translate" class="text-right-sm-left">{{ 'format.kronor' | translate:{ n: c.lgBeloppTotal_cache | localizednumber } }}</td>
                          <td [attr.data-name]="'label.dokument' | translate" class="text-center-sm-left beslut-file">
                            <div class="document-container">
                              @if (c.beslutTyp.typ==='b2') {
                                <individual-b2-link [beslut]="c"></individual-b2-link>
                              }
                              @if (c.beslutTyp.typ!=='b2') {
                                <file-link (click)="beslutFileClicked(c.id)" [file]="c.fil"></file-link>
                              }
                              @if (!c.fil?.datumLast && c.beslutTyp.typ!=='b2') {
                                <fa-icon [icon]="['fas', 'eye-slash']" class="eye-icon" [title]="'label.dokument-ej-hamtat' | translate"></fa-icon>
                              }
                            </div>
                          </td>
                          @if (c.harForsakransKrav) {
                            <td [attr.data-name]="'label.forsakran' | translate" class="text-center-sm-left">
                              <div class="document-container">
                                <span [title]="'label.forsakranskrav-' + (b.arende.handlaggsAvSkatteverket ? 'skv' : 'lst') + '-link' | translate">
                                  <button type="button" (click)="openBesvaraForsakranModal(b.arende)" class="btn nowrap-btn btn-link" [disabled]="disableForsakransLink(c.fil!==null ? c.fil.datumLast : false)">
                                    <fa-icon [icon]="['fas', 'reply']" size="lg" [fixedWidth]="true" class="me-2"></fa-icon>{{'label.besvara' | translate}}
                                  </button>
                                </span>
                              </div>
                            </td>
                          }
                        </tr>
                      }
                    </tbody>
                    <tfoot>
                      <tr>
                        <th [attr.data-name]="'label.antal-beslut' | translate" [title]="'label.antal-beslut' | translate" colspan="3">{{ 'format.antal-beslut' | translate:{ n: b.lonegarantiBeslut.length | localizednumber } }}</th>
                        <th [attr.data-name]="'label.total-lonegaranti' | translate" [title]="'label.total-lonegaranti' | translate" class="text-right-sm-left">{{ 'format.kronor' | translate:{ n: getSum(b.lonegarantiBeslut, 'lgBeloppTotal_cache') | localizednumber } }}</th>
                        <th [attr.colspan]="hasForsakransKrav(b.lonegarantiBeslut) ? 2 : 1"></th>
                      </tr>
                    </tfoot>
                  </table>
                }
                <hr />
                <p class="h5">{{ 'label.mina-bilagor' | translate }}</p>
                @if (!b.bilagor.length) {
                  <p class="text-muted">{{ 'label.inga-bilagor' | translate }}</p>
                }
                @if (b.bilagor.length) {
                  <div class="table-responsive">
                    <table class="table">
                      <thead>
                        <tr>
                          <th scope="col" style="width:120px">{{ 'label.datum' | translate }}</th>
                          <th scope="col">{{ 'label.beskrivning' | translate }}</th>
                          <th scope="col" class="text-center-sm-left" style="width:140px">{{ 'label.dokument' | translate }}</th>
                          <th scope="col" class="text-center-sm-left" style="width:140px">{{ 'label.signera' | translate }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (d of b.bilagor | orderBy:'datumSparat':true; track d) {
                          <tr>
                            <td [attr.data-name]="'label.datum' | translate">{{ d.datumSparat | localizeddate:'shortDate' }}</td>
                            <td [attr.data-name]="'label.beskrivning' | translate">{{ d.beskrivning }}</td>
                            <td [attr.data-name]="'label.dokument' | translate" class="text-center-sm-left beslut-file d-flex align-items-center">
                              <div class="document-container">
                                <file-link [file]="d"></file-link>
                                @if (!d.datumLast) {
                                  <fa-icon [icon]="['fas', 'eye-slash']" class="eye-icon" [fixedWidth]="true" [title]="'label.dokument-ej-hamtat' | translate"></fa-icon>
                                }
                              </div>
                            </td>
                            <td [class.text-center-sm-left]="d.arSigneradAvArbetstagare" [attr.data-name]="'label.signera' | translate">
                              @if (d.skaSignerasAvArbetstagare && !d.arSigneradAvArbetstagare) {
                                <sign [files]="[d]" btnClass="btn-link" (onSuccess)="reloadBeslut()"></sign>
                              }
                              @if (d.arSigneradAvArbetstagare) {
                                <span class="text-muted">{{ 'label.signerad' | translate }}</span>
                              }
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
}
